module.exports = __webpack_public_path__ + "static/media/uparrowmob.225afeae.svg";